import { useEffect } from "react";
import { messagesThunks } from "../store/slice";
import { EntityId } from "@reduxjs/toolkit";
import { useAppDispatch } from "app/hooks";
import { MessageHubMethodNames } from "../hubs/MessageHub";

export const useSignalRGroupSubscriber = (groupId: EntityId | undefined) => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!groupId) return;

        dispatch(
            messagesThunks.sendMessageAsync({
                methodName: MessageHubMethodNames.SubscribeToGroupUpdates,
                payload: groupId,
            }),
        );

        return () => {
            dispatch(
                messagesThunks.sendMessageAsync({
                    methodName:
                        MessageHubMethodNames.UnsubscribeFromGroupUpdates,
                    payload: groupId,
                }),
            );
        };
    }, [dispatch, groupId]);
};
